import { onBeforeUnmount, onMounted, reactive } from 'vue';
import type { LocaleType } from '@/store';

interface LangState {
  value: LocaleType;
}

export const langStore = reactive<LangState>({
  value: (localStorage.getItem('language') as LocaleType) || 'en-US',
});

export function setLang(locale: LocaleType) {
  langStore.value = locale;
  localStorage.setItem('language', locale);
}

export function useLangSync() {
  const onStorage = (event: StorageEvent) => {
    if (event.key === 'language' && event.newValue) {
      langStore.value = event.newValue as LocaleType;
    }
  };

  onMounted(() => window.addEventListener('storage', onStorage));
  onBeforeUnmount(() => window.removeEventListener('storage', onStorage));
}
